import React, { useState, useMemo, useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { withRouter } from 'react-router-dom';
import SavedPaymentMethod from './SavedCard/SavedPaymentMethod';
import ConsentDialog from '../common/ConsentDialog';



import { useDispatch, useSelector } from 'react-redux';
import {
    Input,
    DropdownMenu,
    Button,
    Tab,
    Tabs,
    Column,
    Grid,
    Row,
    Dialog,
    BUTTON_VARIANTS,
    IconStar,
    DialogHeader,
    INPUT_ICON_POSITIONS,
    Loader
} from 'cdk-radial';

import {
    saveCheckoutOption,
    calculateTax,
    resetSalesTax,
    resetCheckOutDetails
} from '../../redux/connectedComponent/paymentCheckout/paymentCheckout.slice';
import Summary from './Summary'
import Autocomplete from './Autocomplete'
import './PaymentCheckout.scss'
import _ from 'lodash';
import { accountConstants } from '../../constants/accountConstants';
import {
    getUserDetails,
    createSolutionTermsConsent as createPaymentTermsConsent
  } from '../../redux/connectedComponent/appTerms/appTerms.slice';
import { consentConstant } from '../../constants/consentConstant';
import { environmentURLs } from '../common/CaptureEnvironment';
import { getSignedS3Url } from '../../redux/connectedComponent/solutionInfo/solutionInfo.slice';

const accountHolderTypes = ['Individual', 'Company'];
const ACCEPTED_STATUS = 'accepted';
const PAYMENT_CONSENT_TYPE ='payments';
const DEALER_PORTAL = 'dealerportal';
const STRIPECARD='stripe_card';
const STRIPEBANK='stripe_bank'
const OFFLINE_ONLINE = 'Offline,Online'


const activeTabStyle = {
    backgroundColor:'#FFFFFF'
}

function PaymentCheckout({
    onClose,
    onCheckOut,
    selectedTab = 0,
    match
}) {
    const dispatch = useDispatch();
    const { solutionInfo, planDetails, monetizationSignedS3Url,selectedPlanId } = useSelector(state => state.solutionInfoSlice);
    const { decodedToken, authenticationToken, userEmail } = useSelector(state => state.loginDetailsSlice);
    const { loginDetailsSlice, paymentCheckoutSlice } = useSelector(state => state)
    const { selectedLocations,selectedLocationsWithCMFNumber } = useSelector(state => state.selectLocationsSlice)
    const [tabSelected, setTabSelect] = useState(selectedTab);
    const [isWarningIndicatorOpen, setIsWarningIndicatorOpen] = useState(false);
    const [paymentCheckoutFormData, setPaymentCheckoutFormData] = useState({});
    const [openConsentDialog, setOpenConsentDialog] = useState(false)
    const [showConsentingInProgress,setShowConsentingInProgress] = useState(false);
    const { address, tax, isLoadingToCalculateTax, isFailedToCalculateTax } = paymentCheckoutSlice.salesTaxRate
    const { paymentSettings } = useSelector(state => state.paymentSettingsSlice)
    const {paymentSettingData,paymentSettingLoading}=paymentSettings
    let cardData=[]
    let achData=[]

    useEffect(()=>{
          dispatch(resetSalesTax());
          dispatch(resetCheckOutDetails())
      	let monetizationAgreementUrl = environmentURLs.MONETIZATION_SERVICE_AGREEMENT_DOC_URL;
          let monetizationAgreementFileName = monetizationAgreementUrl && monetizationAgreementUrl.slice(monetizationAgreementUrl.indexOf('MonetisationServiceAgreement'));
          dispatch(getSignedS3Url({
              type: 'monetizationAgreement',
              operation: 'getObject', 
              expires: '3600', 
              token: authenticationToken, 
              fileName: monetizationAgreementFileName
          }));
    },[])
    const getPlanDetails = () => {
        const { orgId } = solutionInfo;
        let filteredPlan = []; 
        let planId ='';
        (selectedPlanId && selectedPlanId !== '') ? planId=selectedPlanId 
         : planId= match && match.params && match.params.selectedPlanId;
  
        if (Array.isArray(planDetails) && planDetails.length > 0) {
            filteredPlan = planDetails.filter(plan => {
                return plan.id === planId;
            });
            return {
                remittanceOrgId: orgId,
                unitAmount: filteredPlan[0] && filteredPlan[0].basePrice
            }
        }
    }

        const calculateTaxOnAddress = (address) => {
            const orgAndUnit = getPlanDetails();
            dispatch(calculateTax({
                address,
                quantity: selectedLocations ? selectedLocations.length : 0,
                token: loginDetailsSlice.authenticationToken,
                ...orgAndUnit
            }));
        }

        const getRShare = () => {
            let rShare = null;
            if (solutionInfo.payment_info && (solutionInfo.payment_info.paymentMode === 'Online' || solutionInfo.payment_info.paymentMode === OFFLINE_ONLINE)) {
                rShare = solutionInfo.payment_info.paymentOption.stripe
            }
            return rShare
        };

        const handlACHWarningSubmit = async => {
            dispatch(saveCheckoutOption({
                checkoutType: accountConstants.BANK_ACH,
                rShare: getRShare(),
                checkoutDetails: { ...paymentCheckoutFormData },
                paymentSetting:paymentSettingData
            }));
            onCheckOut()
        };

        const handlePaymentCheckoutSubmit = async (paymentCheckoutType,formdata) => {
            setPaymentCheckoutFormData({...formdata,paymentCheckoutType});
            setOpenConsentDialog(true)
        };


        const handlCardSubmit = async formdata => {
            dispatch(saveCheckoutOption({
                checkoutType: accountConstants.CARD,
                rShare: getRShare(),
                checkoutDetails: { ...formdata },
                paymentSetting:paymentSettingData
            }));
            onCheckOut()
        };
        const handleSavedCardSubmit= async formdata=>{
            dispatch(saveCheckoutOption({
                checkoutType: formdata.paymentType === "card" ? 
                  accountConstants.CARD : accountConstants.BANK_ACH,
                rShare: getRShare(),
                checkoutDetails: { ...formdata },
                paymentSetting:paymentSettingData
            }));
            onCheckOut()
        }
        if(Array.isArray(paymentSettingData)){
          cardData=paymentSettingData.filter(item=>item.payment_type===STRIPECARD);
          achData=paymentSettingData.filter(item=>item.payment_type===STRIPEBANK);
        }
        
        const tabItems =[
                                   {
                                        id: accountConstants.CARD,
                                        panelId: accountConstants.CARD,
                                        renderPanel: (props) => <CheckoutFormCard onClose={onClose} 
                                        onFormSubmit={(formdata)=>handlePaymentCheckoutSubmit(accountConstants.CARD,formdata)} 
                                        {...props} 
                                        isDisabled={!tax} 
                                        cardData={cardData} 
                                        isLoading={paymentSettingLoading}/>,
                                        renderTab: (props) => <Tab style={props.isActive?activeTabStyle:{}} label="Card" {...props} />
                                    }
                                    ,
                                    {
                                        id: accountConstants.BANK_ACH,
                                        panelId: accountConstants.BANK_ACH,
                                        renderPanel: (props) => <ACHCheckout onClose={onClose} 
                                        onFormSubmit={(formdata)=>handlePaymentCheckoutSubmit(accountConstants.BANK_ACH,formdata)} 
                                        {...props} 
                                        isDisabled={!tax}
                                        achData={achData} 
                                        isLoading={paymentSettingLoading}/>,
                                        renderTab: (props) => <Tab style={props.isActive?activeTabStyle:{}} label="Bank" {...props} />
                                    }
                        ]

        const saveConsent = async (data)=>{
            setShowConsentingInProgress(true);
            const entityList = selectedLocationsWithCMFNumber.map((selectedLocation) => ({
                entityId: selectedLocation.entityId,
                cmfNumber: selectedLocation.cmfNumber,
              }));
            let loggedInUserEmail = decodedToken && decodedToken.sub;
            let businessRoleData = await dispatch(getUserDetails({
                loggedInUserEmail, firstName: decodedToken.firstName, lastName:decodedToken.lastName, token:authenticationToken
            }));

            let roleData = {};
            if(businessRoleData && businessRoleData.payload && businessRoleData.payload.data){
                roleData = businessRoleData.payload.data;
                roleData.dealershipName = ( Array.isArray(roleData.dealershipName) && roleData.dealershipName.filter(name=> selectedLocations.includes(name))) || [];
            }

            const consentPayload = {
              entityList: entityList,
              email: userEmail,
              firstName: decodedToken.firstName,
              lastName: decodedToken.lastName,
              documentLink: environmentURLs.MONETIZATION_SERVICE_AGREEMENT_DOC_URL,
              solutionId: solutionInfo.id,
              listingVersion: solutionInfo.listingVersion,
              solutionVersion:
                (solutionInfo.overview && solutionInfo.overview.version) || '1',
              reasonForRejection: null,
              status: ACCEPTED_STATUS,
              consentType: PAYMENT_CONSENT_TYPE,
              consentedSource: DEALER_PORTAL,
              apiProviderId: 'payment_consnet_apiProviderid_placeholder',
              apiVersion: null,
              customConsentForm: '',
              businessRoleData: roleData,
            };

            const consentServicePromise = dispatch(
              createPaymentTermsConsent({
                consentPayload,
                solutionId: solutionInfo.id,
                listingVersion: solutionInfo.listingVersion,
                token: authenticationToken,
              })
            );
            
            consentServicePromise.then((consentObject) => {
                 setShowConsentingInProgress(false);  
                if(paymentCheckoutFormData.existingCustomer){
                    handleSavedCardSubmit(paymentCheckoutFormData)
                }else
                {
                  if(paymentCheckoutFormData && paymentCheckoutFormData.paymentCheckoutType === accountConstants.BANK_ACH){
                    handlACHWarningSubmit();
                  }
                  if(paymentCheckoutFormData && paymentCheckoutFormData.paymentCheckoutType === accountConstants.CARD){
                    handlCardSubmit(paymentCheckoutFormData);
                  }
                }
            }).catch(err => {
                console.error("Error occurred while consenting",err);
            });

        }

        return (

            <div className="payment_checkout-wrapper">
                {<div className="payment_checkout">
                    <div className="extra-div"></div>
                    <div className="payment_checkout_info">
                        <Summary 
                            tax={tax}
                            isFailedToCalculateTax={isFailedToCalculateTax} 
                            isLoadingToCalculateTax={isLoadingToCalculateTax} />
                    </div>
                    <div className="payment_checkout_option">
                        <Grid>
                            <Row>
                                <div className="payment_checkout_info_text"> Billing Address </div>
                            </Row>
                            <Row>
                                <Autocomplete
                                    onAddressSelect={calculateTaxOnAddress}
                                    isFailedToCalculateTax={isFailedToCalculateTax}
                                />
                            </Row>
                                <BillingAddress
                                    address={address}
                                    isLoadingToCalculateTax={isLoadingToCalculateTax}
                                />
                        </Grid>

                        <Row>
                            <div className="payment_checkout_info_text"> Pay using </div>
                        </Row>
                        <div className="payment_tabs">
                            <Tabs
                                activeItemIndex={tabSelected}
                                alignment="justified"
                                defaultActiveIndex={0}
                                onActiveItemChange={setTabSelect}
                                items={tabItems}
                                
                            />
                        </div>

                    </div>
                </div>}

                <Dialog id="dialog-payment" hideHeader 
                isOpen={isWarningIndicatorOpen} title={"Verify Bank account"} 
                  hideCloseButton={false}>
                     <DialogHeader
                        closeLabel="Close"
                        hideCloseButton={false}
                        id="header-id"
                        onClose={() => {
                                        setPaymentCheckoutFormData({})
                                        setIsWarningIndicatorOpen(false)
                                    }}
                        title="Verifiy Bank Account"
                        titleId="title-id"
                      />
                    <Grid>
                        <Row>
                            <br/>
                            To verify your ACH you will receive two micro deposits.
                            <br/>
                            <br/>    
                            These deposits will take 1-2 business days to appear on your online 
                            bank statement
                            <br/>  
                        </Row>
                        <Row>
                            <div className='Warning_actions'>
                                <Button
                                    className="payment-checkout_button"
                                    onClick={handlACHWarningSubmit}
                                    text='Okay'
                                />
                            </div>
                        </Row>
                    </Grid>
                </Dialog>



               {openConsentDialog && <ConsentDialog
                    className={'payment-consent-dialog'}
                    type={consentConstant.MONETISATION_SERVICE_AGREEMENT}
                    open={openConsentDialog}
                    title={consentConstant.MONETISATION_SERVICE_AGREEMENT}
                    docUrl={monetizationSignedS3Url}
                    fileName={environmentURLs.MONETIZATION_SERVICE_AGREEMENT_DOC_URL
                        ? environmentURLs.MONETIZATION_SERVICE_AGREEMENT_DOC_URL.slice(environmentURLs.MONETIZATION_SERVICE_AGREEMENT_DOC_URL.lastIndexOf('/') + 1)
                        : 'MonetizationAgreement.pdf'}
                    onAccept={saveConsent}
                    onClose={() => {
                        setOpenConsentDialog(false)
                    }}
                    userInfo={{
                    firstName:  decodedToken && decodedToken.firstName,
                    lastName: decodedToken && decodedToken.lastName
                    }}
                    email={userEmail}
                    token={authenticationToken}
                    oneClickConsentOnly={true}
                    showInProgressState={showConsentingInProgress}
                    inProgressStateMessage={'Consenting in Progress'}
                />}
            </div>
        );
    }



    const useOptions = () => {

        const options = useMemo(
            () => ({
                hidePostalCode: true,
                disabled:false,
                style: {
                    base: {
                        border: "1px solid #aab7c4",
                        fontSize: '18px',
                        fontWeight: 500,
                        letterSpacing: "0.025em",
                        fontFamily: "Source Code Pro, monospace",
                        "::placeholder": {
                            color: "#aab7c4"
                        }
                    },
                    invalid: {
                        color: "#9e2146"
                    }
                }
            }),
        );
        return options;
    };

    const CheckoutFormCard = ({ onFormSubmit, isDisabled,cardData,isLoading }) => {
        const stripe = useStripe();
        const elements = useElements();
        const options = useOptions()
       
        const [formData, updateFormData] = useState({
            name: '',
        });
        const [formExistingPaymentData, updateExistingPaymentDataData] = useState({
            customerReference: null,
            cardReference: null,
            last4: null,
            paymentType: null,
            existingCustomer:true
        });
        const [enableSavedPaymentMethod,setEnablesavedPaymentMethod]=useState(false)
        const [selectedlast4,setSelectedLast4]=useState('XXXX')
        const [formError, setFormError] = useState({});
        const [formChildError,setFormChildError]=useState({})

        const checkIsFormValid = () => {
            let isFormValid = true,
                formErrorValues = {};
            _.map(formData, (value, key) => {
                // eslint-disable-next-line default-case
                switch (key) {
                    case 'name':
                        if (!value || !/^[a-zA-z ]+$/.test(value)) {
                            isFormValid = false;
                            formErrorValues['name'] =
                                'Please enter account name.';
                        }
                        return;
                }
            });
            return { isFormValid, formErrorValues };
        };

        const handleChange = e => {
            updateFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
            setFormError({
                ...formError,
                [e.target.name]: null
            });
        };
        const existingPaymentMethodCheckBoxHandler=()=>{
           setEnablesavedPaymentMethod(!enableSavedPaymentMethod)
        }
        const dropDownMenuSelectionChangeHandler=(e)=>{
            setSelectedLast4(`${e.target.value}`)
            const objPayment = cardData.filter(x=>x.last4 === e.target.value)
            if(objPayment.length>0){
              updateExistingPaymentDataData({
                ...formExistingPaymentData,
                customerReference: objPayment[0].customer_reference,
                cardReference: objPayment[0].payment_type_reference,
                last4: objPayment[0].last4,
                paymentType: objPayment[0].payment_type === STRIPECARD ?'card':'ach',
                existingCustomer:true
             })
            }
        }
        const handlFormSubmit = async (event) => {
            event.preventDefault();
            if(!enableSavedPaymentMethod){
              let { isFormValid, formErrorValues } = checkIsFormValid(formData);

            if (!stripe || !elements || !isFormValid) {
                setFormError(formErrorValues);
                return;
            }

            const cardElement = elements.getElement(CardElement);
            const { token, error } = await stripe.createToken(cardElement);

            if (error) {
                console.log('[error]', error);
            } else {
                onFormSubmit({ token: token.id, ...formData });

            }
            }else{
                if(!formExistingPaymentData.last4 || !formExistingPaymentData.customerReference){
                    formChildError['existingPayment'] =
                                'Please select the last4 digit.';
                     setFormChildError(formChildError);
                     setSelectedLast4(`XXX`)
                     return;
                }
                onFormSubmit({token:'SavedCustomer', ...formExistingPaymentData})   
            }
        };
        if(isLoading) return (
                    <div className="payment_checkout_tab-loader">
                        <Loader
                            data-testid="loader"
                            hideLabel={false}
                            label="Loading..."
                            spinnerClassName=""
                            variant="inline"
                        />
                    </div>
           )
        return (
            <div className="payment_checkout_tab">
               {cardData.length > 0 ? 
               (<><div className="savedPaymentMethodDiv">
                 <SavedPaymentMethod data={cardData} 
                    checkBoxHandler={existingPaymentMethodCheckBoxHandler}
                    dropdownSelectionHandler={dropDownMenuSelectionChangeHandler}
                    isCheckBoxChecked={enableSavedPaymentMethod} 
                    last4={selectedlast4} formError={formChildError}/>
                </div>
                 <div className="div-separator">
                </div></>) :
                (<div></div>) }
                <Grid className="checkout-form">
                    <Row>
                        <Column
                            l={12}
                            xs={12}>
                            <Input
                                required
                                label="Account holder name"
                                name="name"
                                fullWidth
                                value={formData.name || ''}
                                onChange={handleChange}
                                enableCustomValidation
                                hasError={formError.name}
                                icon={<IconStar />} iconPosition={INPUT_ICON_POSITIONS.TRAILING}
                                isDisabled={enableSavedPaymentMethod}
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column className={!enableSavedPaymentMethod ? "payment_cardelement":"payment_cardelement_disable"} l={12} xs={12}>
                            <CardElement options={options} />
                        </Column>
                    </Row>
                    <Row>

                        <Button
                            isDisabled={isDisabled}
                            className="checkout_button"
                            onClick={handlFormSubmit}
                            text='Subscribe'
                            variant={BUTTON_VARIANTS.PRIMARY}
                        />

                    </Row>
                    </Grid>
            </div>)
    };


    function ACHCheckout({
        onClose,
        onFormSubmit,
        isDisabled,
        achData,
        isLoading
    }) {
        const [formData, updateFormData] = useState({
            accountHolderType: null,
            routingNumber: null,
            accountNumber: null,
            accountHolderName: null
        });
        const [formExistingPaymentData, updateExistingPaymentDataData] = useState({
            customerReference: null,
            cardReference: null,
            last4: null,
            paymentType: null,
            existingCustomer:true
        });
        const [enableExisExistingPaymentMethod,setEnableExistingPaymentMethod]=useState(false)
        const [selectedlast4,setSelectedLast4]=useState('XXXX')
        const [formError, setFormError] = useState({});
        const [formChildError,setFormChildError]=useState({})

        const handleChange = e => {
            updateFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
            setFormError({
                ...formError,
                [e.target.name]: null
            });
        };
        const existingPaymentMethodCheckBoxHandler=()=>{
           setEnableExistingPaymentMethod(!enableExisExistingPaymentMethod)
        }

        const checkIsFormValid = () => {
            let isFormValid = true,
                formErrorValues = {};
            _.map(formData, (value, key) => {
                // eslint-disable-next-line default-case
                switch (key) {
                    case 'accountHolderName':
                        if (!value || !/^[a-zA-z ]+$/.test(value)) {
                            isFormValid = false;
                            formErrorValues['accountHolderName'] =
                                'Please enter account holder name.';
                        }
                        return;
                    case 'accountHolderType':
                        if (!value) {
                            isFormValid = false;
                            formErrorValues['accountHolderType'] =
                                'Please select account holder type.';
                        }
                        return;
                    case 'routingNumber':
                        if (!value || !/^[0-9]{7,12}$/.test(value)) {
                            isFormValid = false;
                            formErrorValues['routingNumber'] =
                                'Please enter valid routing number.';
                        }
                        return;
                    case 'accountNumber':
                        if (!value || !/^[a-zA-Z0-9-_\!\@\#\$\%\^&\*]{5,16}$/.test(value)) {
                            isFormValid = false;
                            formErrorValues['accountNumber'] =
                                'Please enter valid account number .';
                        }
                        return;
                }
            });
            return { isFormValid, formErrorValues };
        };

        const handlFormSubmit = async e => {
         if(!enableExisExistingPaymentMethod){
            e.preventDefault();
            let { isFormValid, formErrorValues } = checkIsFormValid(formData);
            if (isFormValid) {
                onFormSubmit(formData);
            } else {
                setFormError(formErrorValues);
            }
            return false;
          } else{
                if(!formExistingPaymentData.last4 || !formExistingPaymentData.customerReference){
                    formChildError['existingPayment'] =
                                'Please select the last4 digit.';
                     setFormChildError(formChildError);
                     setSelectedLast4(`XXX`)
                     return;
                }
                onFormSubmit({token:'SavedCustomer', ...formExistingPaymentData})

          }
        };
         const dropDownMenuSelectionChangeHandler=(e)=>{
            setSelectedLast4(`${e.target.value}`)
            const objPayment = achData.filter(x=>x.last4 === e.target.value)
            if(objPayment.length>0){
              updateExistingPaymentDataData({
                ...formExistingPaymentData,
                customerReference: objPayment[0].customer_reference,
                cardReference: objPayment[0].payment_type_reference,
                last4: objPayment[0].last4,
                paymentType: objPayment[0].payment_type === STRIPECARD ?'card':'ach',
                existingCustomer:true
             })
            }
        }

        if(isLoading) return (
                        <div className="payment_checkout_tab-loader"><Loader
                            data-testid="loader"
                            hideLabel={false}
                            label="Loading..."
                            spinnerClassName=""
                            variant="inline"
                        /></div>
           )

        return (
            <div className="payment_checkout_tab">
                <form>
                {achData.length > 0 ? 
                  (<><div className="savedPaymentMethodDiv">
                    <SavedPaymentMethod data={achData} 
                      checkBoxHandler={existingPaymentMethodCheckBoxHandler}
                      dropdownSelectionHandler={dropDownMenuSelectionChangeHandler}
                      isCheckBoxChecked={enableExisExistingPaymentMethod} 
                      last4={selectedlast4} formError={formChildError}/>
                   </div>
                   <div className="div-separator">
                </div></>) :
                (<div></div>) }
                    <Grid className="checkout-form">
                        <Row>
                            <Input
                                required
                                enableCustomValidation
                                hasError={formError.accountHolderName}
                                label="Account holder name"
                                name="accountHolderName"
                                fullWidth
                                value={formData.accountHolderName || ''}
                                onChange={handleChange}
                                icon={<IconStar />} iconPosition={INPUT_ICON_POSITIONS.TRAILING}
                                isDisabled={enableExisExistingPaymentMethod}
                            />
                        </Row>
                        <Row>
                            <DropdownMenu
                                required
                                enableCustomValidation
                                isDisabled={enableExisExistingPaymentMethod}
                                hasError={formError.accountHolderType}
                                label="Select account type"
                                fullWidth
                                value={{ value: formData.accountHolderType, label: formData.accountHolderType }}
                                onChange={({ value }) => {
                                    handleChange({ target: { name: 'accountHolderType', value } })
                                }}

                                options={accountHolderTypes.map(type => ({ value: type, label: type }))}
                            >
                            </DropdownMenu>
                        </Row>
                        <Row>
                            <Input
                                required
                                enableCustomValidation
                                hasError={formError.accountNumber}
                                label="Account number"
                                name="accountNumber"
                                fullWidth
                                value={formData.accountNumber || ''}
                                onChange={handleChange}
                                icon={<IconStar />} iconPosition={INPUT_ICON_POSITIONS.TRAILING}
                                isDisabled={enableExisExistingPaymentMethod}
                            />

                        </Row>
                        <Row>
                            <Input
                                required
                                enableCustomValidation
                                hasError={formError.routingNumber}
                                label="Routing number"
                                name="routingNumber"
                                fullWidth
                                value={formData.routingNumber || ''}
                                onChange={handleChange}
                                icon={<IconStar />} iconPosition={INPUT_ICON_POSITIONS.TRAILING}
                                isDisabled={enableExisExistingPaymentMethod}
                            />
                        </Row>
                         <Row>
                            <Button
                                isDisabled={isDisabled}
                                className="checkout_button"
                                onClick={handlFormSubmit}
                                text='Subscribe'
                                variant={BUTTON_VARIANTS.PRIMARY}
                            />
                        </Row>
                         </Grid>
                </form>
            </div>
        );
    }

    function BillingAddress(props) {
        let { street = '', address = '', zip = '', city = '', state = '' } = props.address
        return (
            <form>
                <Grid >

                    <Row>
                        <Input
                            isDisabled={true}
                            label="Street name"
                            fullWidth
                            value={`${street} ${address}`}
                        />
                    </Row>

                    <Row>
                        <Input
                            isDisabled={true}
                            label="City"
                            fullWidth
                            value={city}
                        />
                    </Row>

                    <Row>
                        <Column
                            l={6}
                        >
                            <Input
                                className='input-state'
                                isDisabled={true}
                                label="State"
                                fullWidth
                                value={state}
                            />
                        </Column>
                        <Column
                            l={6}
                        >
                            <Input
                                className='input-zip'
                                isDisabled={true}
                                label="Zip code"
                                fullWidth
                                value={zip}
                            />
                        </Column>
                    </Row>

                </Grid>

            </form>

        );
    }


    export default withRouter(PaymentCheckout)
